import ListItem from "./ListItem";
import ListItemHeader from "./ListItemHeader";

ListItem.Header = ListItemHeader;

export default ListItem;
